import { render, staticRenderFns } from "./editCdkey.vue?vue&type=template&id=fa302916&scoped=true"
import script from "./editCdkey.vue?vue&type=script&lang=js"
export * from "./editCdkey.vue?vue&type=script&lang=js"
import style0 from "./editCdkey.vue?vue&type=style&index=0&id=fa302916&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa302916",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/yunxiao/be-3sdnltdmmjqei95chipgpfz5/runner/__flow_work/__flow_builds/182a3969-2a32-4dff-94d8-cf1bbedf203a/workspace/crmeb-mer-admin_BNnv/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa302916')) {
      api.createRecord('fa302916', component.options)
    } else {
      api.reload('fa302916', component.options)
    }
    module.hot.accept("./editCdkey.vue?vue&type=template&id=fa302916&scoped=true", function () {
      api.rerender('fa302916', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/components/editCdkey.vue"
export default component.exports